/**
 * Build 64 (Daniel 2026-09-27): the Today list. See routes/today.ts.
 */
import { apiFetch } from '../auth/api';

export interface TodayItem {
  key: string;
  contact_id: number | null;
  lead_id: number | null;
  transaction_id: number | null;
  name: string;
  phone: string | null;
  why: string;
  at: number | null;
  link: string;
  task?: { kind: 'contact' | 'team'; id: number };
}
export interface TodaySection { key: string; title: string; items: TodayItem[] }
export interface TodayResponse {
  generated_at: number;
  scope: 'me' | 'team';
  can_see_team: boolean;
  total: number;
  sections: TodaySection[];
}

export function getToday(scope: 'me' | 'team' = 'me'): Promise<TodayResponse> {
  return apiFetch(`/api/today${scope === 'team' ? '?scope=team' : ''}`);
}

/** Build 86: the agent's own 1:1 commitments, at the top of Today. */
export interface MyCommitment {
  id: number;
  title: string;
  due_date: number | null;
  status: 'open' | 'done';
  completed_at: number | null;
  from_meeting_at: number;
}
export function getMyCommitments(): Promise<{ items: MyCommitment[] }> {
  return apiFetch('/api/today/commitments');
}
export function setMyCommitment(id: number, status: 'open' | 'done'): Promise<{ ok: true }> {
  return apiFetch(`/api/today/commitments/${id}`, { method: 'PATCH', body: JSON.stringify({ status }) });
}
